export const REVIEW_REFILL_THRESHOLD = 5;
export const FACT_PREVIEW_MINIMUM_MS = 4_000;

export function factsPreviewRemainingMs({ hasFacts, alreadyPresented, reviewedCount, firstShownAt, now }: {
  hasFacts: boolean;
  alreadyPresented: boolean;
  reviewedCount: number;
  firstShownAt: number | null;
  now: number;
}): number {
  if (!hasFacts || alreadyPresented || reviewedCount > 0 || firstShownAt === null) return 0;
  return Math.max(0, FACT_PREVIEW_MINIMUM_MS - Math.max(0, now - firstShownAt));
}

export function reviewPollInterval(pendingCount: number): number {
  return pendingCount <= REVIEW_REFILL_THRESHOLD ? 1_000 : 3_000;
}

// A drained queue is not a new upload. Preserve the review workspace even
// after a refresh, using durable reviewed counts rather than a local flag.
export function emptyReviewPhase(status: string, reviewedCount: number) {
  if (status === 'completed' || status === 'cancelled') return 'complete';
  if (status === 'failed_terminal') return 'error';
  return reviewedCount > 0 ? 'reviewing' : 'preparing';
}
